import { clearStandalonePopupSession } from './standalone-payment-popup';

export const PAYMENT_COMPLETE_MESSAGE_TYPE = 'joygames-payment-complete';
export const H5_PAYMENT_CLOSE_URL_KEY = 'h5PaymentCloseUrl';
export const H5_PAYMENT_REF_ID_KEY = 'h5PaymentRefId';

export type PaymentCompleteDetail = {
  type: typeof PAYMENT_COMPLETE_MESSAGE_TYPE;
  success: boolean;
  refId?: string;
};

/** Lưu closeUrl từ query (game/WebView truyền vào) để dùng sau redirect MoMo. */
export function persistPaymentCloseUrlFromSearch(search = window.location.search): void {
  const closeUrl = new URLSearchParams(search).get('closeUrl');
  if (closeUrl) {
    sessionStorage.setItem(H5_PAYMENT_CLOSE_URL_KEY, closeUrl);
  }
}

export function getPaymentCloseUrl(): string | null {
  return sessionStorage.getItem(H5_PAYMENT_CLOSE_URL_KEY);
}

export function notifyPaymentComplete(refId?: string): void {
  const detail: PaymentCompleteDetail = {
    type: PAYMENT_COMPLETE_MESSAGE_TYPE,
    success: true,
    refId,
  };

  try {
    if (window.opener && !window.opener.closed && window.opener !== window) {
      window.opener.postMessage(detail, '*');
    }
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(detail, '*');
    }
  } catch {
    /* ignore */
  }

  window.dispatchEvent(new CustomEvent(PAYMENT_COMPLETE_MESSAGE_TYPE, { detail }));

  const w = window as Window & {
    android?: { closeWindow?: () => void; close?: () => void };
    webkit?: { messageHandlers?: { closeWindow?: { postMessage: (v: unknown) => void } } };
    JsBridge?: { close?: () => void };
  };

  w.android?.closeWindow?.();
  w.android?.close?.();
  w.JsBridge?.close?.();
  w.webkit?.messageHandlers?.closeWindow?.postMessage(null);
}

/**
 * Thử đóng tab/cửa sổ thanh toán. Trình duyệt thường chặn window.close() nếu tab không do script mở.
 * @returns true nếu có thể đã đóng hoặc đã chuyển hướng (closeUrl / history)
 */
export function tryClosePaymentWindow(refId?: string): boolean {
  notifyPaymentComplete(refId);
  clearStandalonePopupSession();

  const closeUrl = getPaymentCloseUrl();
  if (closeUrl) {
    sessionStorage.removeItem(H5_PAYMENT_CLOSE_URL_KEY);
    window.location.replace(closeUrl);
    return true;
  }

  window.close();
  window.setTimeout(() => window.close(), 150);

  if (window.history.length > 1) {
    window.history.back();
    return true;
  }

  return false;
}

/** Gọi sau tryClose — nếu document vẫn còn visible thì close bị chặn. */
export function wasCloseLikelyBlocked(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'visible';
}
